import PropTypes from 'prop-types';

export const CapFindingPropTypes = {
  allExternalUsersId: PropTypes.array,
  isFactoryUser: PropTypes.bool.isRequired,
  isResponsiblePersonEditable: PropTypes.bool.isRequired,
  canDonwloadAttachment: PropTypes.bool,
  finding: PropTypes.object,
  isActionEditible: PropTypes.func,
  isFindingEditible: PropTypes.bool,
  jobStatus: PropTypes.string,
  refetchCapHistories: PropTypes.func,
  updateCapQueryCache: PropTypes.func,
  isExternalUser: PropTypes.bool.isRequired,
  checklist: PropTypes.object,
};

export const CapFindingDefaultProps = {
  allExternalUsersId: [],
  findingSectionNumber: ''
};
